import { Typography, FONT_FAMILY, ColorSAP, Loading } from '../../ontego-ui';

import Backdrop from '@mui/material/Backdrop';
import Styled from './BackdropStyles';

const GeneralBackdrop = props => {
    const { open } = props

    return (
        <Backdrop
            style={{
                zIndex: 100000,
                background: `rgba(42, 46, 52, 1, 0.65)`,
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden"
            }}
            open={open}
        >
            <div>
                <Styled.Loading>
                    <Loading />
                </Styled.Loading>
                <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', width: '100%' }}>
                    <Typography
                        fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD}
                        size={18}
                        color={ColorSAP.neutral[0]}
                    >
                        {`Loading...`}
                    </Typography>
                </div>
            </div>
        </Backdrop>
    )
}

export default GeneralBackdrop